"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransferFormCms = void 0;
var TransferFormCms = /** @class */ (function () {
    function TransferFormCms() {
        this.currentNumberLabel = 'Enter your current number';
        this.consentLabel = "Check if you can keep your number. If so we'll make the\n        transfer easy! Just don't cancel your existing service-that'll\n        happen when you activate your new device.";
        this.tradeInPromoTransferNumberLabel = "<strong>Looks like you won't be able to transfer your number.</strong>\n     We'll update your cart to remove the port-in offer. Don't worry, you may still qualify for\n      the trade-in offer.";
        this.otherPromoTransferNumberLabel = "(If we can't complete your number transfer, you won't be eligible for\n     the port-in offer.)";
        this.retailerAlertError = "Without a number transfer, you don't qualify for $[0] in bill credits for this line.\n      But good news, you'll still <strong>get $[1] in bill credits</strong> applied over [2] months (starts within 3 bills).";
    }
    return TransferFormCms;
}());
exports.TransferFormCms = TransferFormCms;
//# sourceMappingURL=TransferForm.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/components/panels/DeviceOptionsPanel/DeviceCard/ExpandedFormOptions/TransferForm/TransferForm.cms.js
// module id = 928
// module chunks = 8